var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-review-entry"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "entry-card"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1) : _vm.fatalError ? _c('div', {
    staticClass: "entry-card"
  }, [_c('h2', [_vm._v("Verify your identity")]), _c('div', {
    staticClass: "entry-error"
  }, [_vm._v(_vm._s(_vm.fatalError))])]) : _c('div', {
    staticClass: "entry-card"
  }, [_c('h2', [_vm._v("Verify your identity")]), _vm.sentTo.length ? _c('p', [_vm._v(" Enter the 6-digit code we sent to "), _c('strong', [_vm._v(_vm._s(_vm.sentTo.join(', ')))]), _vm._v(" to continue to the enrollment review. ")]) : _c('p', [_vm._v("Enter the 6-digit code we sent you to continue to your enrollment review.")]), _vm._m(0), _c('v-otp-input', {
    ref: "otpInput",
    attrs: {
      "input-classes": "otp-input",
      "separator": "-",
      "num-inputs": 6,
      "should-auto-focus": true,
      "is-input-num": true
    },
    on: {
      "on-change": _vm.onChange,
      "on-complete": _vm.onChange
    }
  }), _vm.error ? _c('div', {
    staticClass: "entry-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _c('button', {
    staticClass: "entry-submit",
    attrs: {
      "type": "button",
      "disabled": !_vm.isComplete || _vm.isVerifying
    },
    on: {
      "click": _vm.verify
    }
  }, [_vm.isVerifying ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Verify ")], 1), _c('login-otp', {
    attrs: {
      "expirySecond": _vm.resendCooldownSeconds,
      "setSpinnerLoader": _vm.isResending
    },
    on: {
      "sendOTP": _vm.resend
    }
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "otp-label"
  }, [_vm._v("Enter Code"), _c('span', {
    staticClass: "required-label"
  }, [_vm._v("*")])]);

}]

export { render, staticRenderFns }